import { defineMessages } from 'react-intl';

export default defineMessages({
    claimDetails: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Claim Details',
        defaultMessage: 'Claim Details',
    },  
    lossDate: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Loss Date',
        defaultMessage: 'Loss Date',
    },
    lossLocation: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Loss Location',
        defaultMessage: 'Loss Location',
    },
    lossAmount: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Loss Amount',
        defaultMessage: 'Loss Amount',
    },
    comments: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Comments',
        defaultMessage: 'Comments',
    },    
    claimDetailsForThisHome: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Claim Details for This Home',
        defaultMessage: 'Claim Details for This Home'
    },
    anotherClaimDetails: {
        id: 'quoteandbind.views.ba-risk-analysis.Add Another Claim Details?',
        defaultMessage: 'Add Another Claim Details?'
    },
    addClaimDetails: {
        id:'quoteandbind.views.ba-risk-analysis.Add Claim Details',
        defaultMessage:'Add Claim Details'
    },
    claimCount: {
        id: 'quoteandbind.views.ba-risk-analysis.Claim:',
        defaultMessage: 'Claim : { count }'
    },
    selectOneCoverage:{
        id: 'quoteandbind.views.ba-risk-analysis.Please select at least one coverage to proceed',
        defaultMessage: 'Please select at least one coverage to proceed'        
    },
    removeClaimHeading:{
        id: 'quoteandbind.views.ba-risk-analysis.Remove Claim?',
        defaultMessage: 'Remove Claim?' 
    },
    removeClaimBody:{
        id: 'quoteandbind.views.ba-risk-analysis.Are you sure you want to remove this claim from the list?',
        defaultMessage: 'Are you sure you want to remove this claim from the list?' 
    },
    driver: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Driver',
        defaultMessage: 'Driver',
    },
    vehicle: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Vehicle',
        defaultMessage: 'Vehicle',
    },
    atfaultpercent: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.At fault percent',
        defaultMessage: 'At fault percent',
    },
    liabilty: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Liabilty',
        defaultMessage: 'Liabilty',
    },
    riskAB: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.AB',
        defaultMessage: 'AB',
    },
    RiskComp: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Comp',
        defaultMessage: 'Comp',
    },
    RiskAPColl: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.AP/Coll',
        defaultMessage: 'AP/Coll',
    },
    RiskDCPD: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.DCPD',
        defaultMessage: 'DCPD',
    },
    RiskSP: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.SP',
        defaultMessage: 'SP',
    },
    RiskAdd: {
        id: 'quoteandbind.views.ba-risk-analysis.Add',
        defaultMessage: 'Add',
    },
    RiskChargeable: {
        id: 'quoteandbind.ba.views.ba-risk-analysis.Chargeable',
        defaultMessage: 'Chargeable',
    }
});
